"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_property_decorator_1 = require("vue-property-decorator");
const vuex_1 = require("vuex");
const modules_1 = require("@/store/modules");
const utils_1 = require("@/store/modules/vehicleSelector/utils");
const consumption_component_vue_1 = tslib_1.__importDefault(require("@/components/consumption/consumption-component.vue"));
const utils_2 = require("@/utils");
const types_1 = require("@/store/modules/vmds/types");
const emission_component_vue_1 = tslib_1.__importDefault(require("../emission-component/emission-component.vue"));
const modal_vue_1 = tslib_1.__importDefault(require("@/components/modal/modal.vue"));
const eco_rating_vue_1 = tslib_1.__importDefault(require("@/components/eco-rating/eco-rating.vue"));
const pls_price_ui_vue_1 = tslib_1.__importDefault(require("@/components/pls-price-ui/pls-price-ui.vue"));
const TrackingManager_1 = require("@/utils/TrackingManager");
const CH_PRICE_DISCLAIMER_TEXT = {
    it: 'Prezzo di listino lordo consigliato non vincolante, IVA inclusa. Tutti i prezzi forniti sono prezzi consigliati non vincolanti dell’importatore Mercedes-Benz Svizzera SA. Il partner commerciale ha piena libertà nella determinazione dei prezzi. Le dotazioni illustrate dei veicoli non sono vincolanti. Le immagini possono contenere accessori o equipaggiamenti a richiesta che non fanno parte della dotazione di serie.',
    fr: "Prix de vente brut recommandé à titre indicatif. Tous les prix mentionnés correspondent à des recommandations de prix sans engagement de l'importateur Mercedes-Benz Suisse SA. Les partenaires de distribution sont libres de fixer leurs prix. Les caractéristiques d'équipement illustrées des véhicules ne sont pas contractuelles. Les illustrations peuvent présenter des accessoires et des options qui ne font pas partie du contenu de la livraison de série.",
    de: 'Unverbindlich empfohlener Bruttolistenpreis inkl. MWST. Sämtliche Preisangaben sind unverbindliche Preisempfehlungen des Importeurs Mercedes-Benz Schweiz AG. Der Vertriebspartner ist in seiner Preisgestaltung frei. Die abgebildeten Ausstattungsmerkmale der Fahrzeuge sind nicht verbindlich. Die Abbildungen können Zubehör und Sonderausstattungen enthalten, die nicht zum serienmässigen Lieferumfang gehören.',
};
function chDisclaimerLangFromAppLanguage(language, locale) {
    const fromLang = (language || '').toLowerCase().split(/[-_]/)[0];
    if (fromLang === 'it' || fromLang === 'fr' || fromLang === 'de') {
        return fromLang;
    }
    const fromLocale = (locale || '').toLowerCase().split(/[-_]/)[0];
    if (fromLocale === 'it' || fromLocale === 'fr' || fromLocale === 'de') {
        return fromLocale;
    }
    return 'de';
}
let VehicleCard = class VehicleCard extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.environmentalDiscountModalIsOpen = false;
    }
    toggleEnvironmentalDiscountModal() {
        this.environmentalDiscountModalIsOpen = !this.environmentalDiscountModalIsOpen;
    }
    getTransmission(transmission) {
        switch (transmission) {
            case types_1.Transmission.AUTOMATIC:
                return this.translate('automaticTransmission');
            case types_1.Transmission.MANUAL:
                return this.translate('manualTransmission');
            default:
                return (0, utils_1.capitalize)(transmission);
        }
    }
    get formattedTransmission() {
        return this.getTransmission(this.currentVehicle.transmissionType);
    }
    get fuelType() {
        const mainFuelType = (0, utils_1.getMainFuelType)(this.currentVehicle.fuelTypes);
        switch (mainFuelType) {
            case types_1.FuelType.DIESEL:
                return this.translate('diesel');
            case types_1.FuelType.PETROL:
                return this.translate('petrol');
            case types_1.FuelType.PETROL_PLUS:
                return this.translate('petrolPlus');
            case types_1.FuelType.ELECTRIC:
                return this.translate('electric');
            default:
                return (0, utils_1.formatFuelType)(mainFuelType);
        }
    }
    get isHybrid() {
        return (0, utils_2.isHybrid)(this.currentVehicle.engineConcept);
    }
    get formattedFuelType() {
        if (this.isHybrid) {
            return `${this.translate('hybrid')} (${this.fuelType}) `;
        }
        return this.fuelType;
    }
    get priceReferences() {
        var _a;
        return (_a = this.outputsConfig.priceReferences) !== null && _a !== void 0 ? _a : [];
    }
    get chPriceDisclaimerText() {
        const lang = chDisclaimerLangFromAppLanguage(this.language, this.locale);
        return CH_PRICE_DISCLAIMER_TEXT[lang];
    }
    get priceSuffix() {
        const key = 'priceSuffix';
        const translation = this.translate(key);
        return translation !== key ? ` ${translation}` : '';
    }
    get priceType() {
        if (!this.defaultCustomerType) {
            return '';
        }
        const isBusiness = this.defaultCustomerType === utils_2.CUSTOMER_TYPE.BUSINESS;
        const priceTag = (0, utils_2.getValidPriceTag)(this.currentVehicle, isBusiness);
        return priceTag === 'netPrice' ? this.translate('vatExcluded') : this.translate('vatIncluded');
    }
    get openVehicleSelectorButtonLabel() {
        return this.isModelSelector ? this.translate('chooseAnotherModel') : this.translate('chooseAnotherBodyType');
    }
    get environmentalDiscountText() {
        if ((0, utils_1.getMainFuelType)(this.currentVehicle.fuelTypes) === types_1.FuelType.ELECTRIC) {
            return this.translate('environmentalDiscountEletric');
        }
        return this.translate('environmentalDiscountHybrid');
    }
    get efficiencyRating() {
        var _a;
        return (_a = this.currentEmissions) === null || _a === void 0 ? void 0 : _a.energyEfficiencyClass;
    }
    get isWLTPv2() {
        return this.outputsConfig.wltp.type === 'v2';
    }
    get isValidEfficiencyRating() {
        const validRatings = ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D', 'E', 'F', 'G'];
        return validRatings.includes(this.efficiencyRating);
    }
    get connectorWordTranslation() {
        if (this.market !== 'DE') {
            return '';
        }
        return this.translate('upTo');
    }
    get shouldShowPls() {
        return utils_2.plsMarkets.includes(this.market);
    }
    get enginePower() {
        const { enginePower } = this.currentVehicle;
        const [firstEngine, secondEngine] = enginePower;
        const firstEnginePower = firstEngine ? `${firstEngine.value} ${firstEngine.unit}` : null;
        if (secondEngine) {
            const secondEnginePower = `${secondEngine.value} ${secondEngine.unit}`;
            return `${firstEnginePower} + ${this.connectorWordTranslation} ${secondEnginePower}`;
        }
        return firstEnginePower;
    }
    onVehicleSelectorClick() {
        TrackingManager_1.tracking.update('change_vehicle');
        this.toggleVehicleSelector();
    }
};
VehicleCard = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'VehicleCard',
        components: {
            ConsumptionComponent: consumption_component_vue_1.default,
            EmissionComponent: emission_component_vue_1.default,
            Modal: modal_vue_1.default,
            EcoRating: eco_rating_vue_1.default,
            PlsPriceUi: pls_price_ui_vue_1.default,
        },
        computed: Object.assign({}, (0, vuex_1.mapGetters)([
            'translate',
            'isModelSelector',
            'currentVehicle',
            'currentVehiclePrice',
            'defaultCustomerType',
            'market',
            'language',
            'outputsConfig',
            'currentEmissions',
            'locale',
            'isEcoRatingEnabled',
            'currentConsumption',
            'currentEngine',
        ])),
        methods: Object.assign({}, (0, vuex_1.mapActions)(modules_1.MODULES.VEHICLE_SELECTOR, ['toggleVehicleSelector'])),
    })
], VehicleCard);
exports.default = VehicleCard;
